<template>
  <v-alert :type="notification.type" border="left" @input="closeNotification(notification.id)" dismissible>
    {{ notification.message }}
  </v-alert>
</template>

<script lang="ts">
import Vue from 'vue';
import { Notification, closeNotification } from '@/modules/notification-center';

export default Vue.extend({
  props: {
    notification: Object as () => Notification
  },
  methods: {
    closeNotification
  }
});
</script>

<style lang="scss" scoped>
.v-alert {
  margin-bottom: 0;
  margin-top: 16px;
}
</style>
